import LogsSpidListPage from "./pages/LogsSpidListPage.vue";
export default { LogsSpidListPage };
